import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { medicationError } from "@/lib/profileValidation";

export const MedicationFields = ({ medication: med, index, prefix, onChange, onRemove, showErrors }) => {
  const error = showErrors ? medicationError(med) : "";
  const id = `${prefix}-med`;
  return (
    <div className="border-b border-emerald-100 pb-5 space-y-3" data-testid={`${id}-row-${index}`}>
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium" data-testid={`${id}-label-${index}`}>Medication {index + 1}</p>
        <Button type="button" variant="ghost" size="icon" onClick={onRemove}
          aria-label={`Remove medication ${index + 1}`} title="Remove medication" data-testid={`${id}-remove-${index}`}>
          <X className="w-4 h-4" />
        </Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <Label htmlFor={`${id}-name-${index}`}>Generic name</Label>
          <Input id={`${id}-name-${index}`} className="rounded-xl mt-1.5" placeholder="e.g. metformin"
            value={med.name || ""} disabled={!!med.brand_name?.trim() && !med.name?.trim()}
            maxLength={120} onChange={(e) => onChange({ name: e.target.value })} data-testid={`${id}-name-${index}`} />
        </div>
        <div>
          <Label htmlFor={`${id}-brand-${index}`}>Brand name</Label>
          <Input id={`${id}-brand-${index}`} className="rounded-xl mt-1.5" placeholder="e.g. Glucophage"
            value={med.brand_name || ""} disabled={!!med.name?.trim() && !med.brand_name?.trim()}
            maxLength={120} onChange={(e) => onChange({ brand_name: e.target.value })} data-testid={`${id}-brand-${index}`} />
        </div>
        <div>
          <Label htmlFor={`${id}-dose-${index}`}>Dosage amount & unit *</Label>
          <Input id={`${id}-dose-${index}`} className="rounded-xl mt-1.5" placeholder="e.g. 500 mg, 1 tablet"
            required maxLength={100} value={med.dose || ""} onChange={(e) => onChange({ dose: e.target.value })}
            aria-invalid={!!error} aria-describedby={error ? `${id}-error-${index}` : undefined} data-testid={`${id}-dose-${index}`} />
        </div>
        <div>
          <Label htmlFor={`${id}-freq-${index}`}>Frequency (optional)</Label>
          <Input id={`${id}-freq-${index}`} className="rounded-xl mt-1.5" placeholder="e.g. twice daily"
            maxLength={120} value={med.frequency || ""} onChange={(e) => onChange({ frequency: e.target.value })} data-testid={`${id}-freq-${index}`} />
        </div>
      </div>
      <p className="text-xs text-slate-500" data-testid={`${id}-name-hint-${index}`}>Generic or brand name — one only.</p>
      {error && <p id={`${id}-error-${index}`} role="alert" className="text-sm text-red-700" data-testid={`${id}-error-${index}`}>{error}</p>}
    </div>
  );
};